var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1116601048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.66758 11.7001C5.59584 11.7747 5.50375 11.8254 5.40336 11.8456L3.60973 12.2093C3.52792 12.2262 3.4433 12.2223 3.36334 12.1978C3.28338 12.1733 3.21055 12.1291 3.15128 12.069C3.09201 12.0089 3.04813 11.9348 3.02352 11.8533C2.99891 11.7717 2.99432 11.6852 3.01016 11.6014L3.37092 9.75189C3.39019 9.6517 3.43791 9.55954 3.50811 9.48692L10.6979 2.15108C10.7931 2.05431 10.9218 2 11.0561 2C11.1903 2 11.3191 2.05431 11.4143 2.15108L12.8522 3.62136C12.9469 3.71871 13 3.85038 13 3.98764C13 4.12489 12.9469 4.25657 12.8522 4.35391L5.66758 11.7001ZM11.0485 3.25249L9.97126 4.35391L10.6979 5.07606L11.7751 3.98504L11.0485 3.25249ZM3.50811 14.381H12.4915C12.6262 14.381 12.7555 14.3262 12.8508 14.2288C12.9461 14.1314 12.9996 13.9992 12.9996 13.8614C12.9996 13.7236 12.9461 13.5915 12.8508 13.494C12.7555 13.3966 12.6262 13.3419 12.4915 13.3419H3.50811C3.37335 13.3419 3.24411 13.3966 3.14882 13.494C3.05353 13.5915 3 13.7236 3 13.8614C3 13.9992 3.05353 14.1314 3.14882 14.2288C3.24411 14.3262 3.37335 14.381 3.50811 14.381Z",
    fill: "#00A751"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeEdit);
export default __webpack_public_path__ + "static/media/treeEdit.04cdb323e2d8ec7797ae9231d6272af4.svg";
export { ForwardRef as ReactComponent };